import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';


function PurchaseRegisterReport() {

    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);


    const handleChildInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);

    };



    const fetchTableData = async () => {
        const itemid = 0;
        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/PurchaseRegister/${companyId}/${itemid}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');


    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };


    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = [`Purchase Data From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);
        const headerRow = ['Bill Date', 'Bill No', 'Name', 'GST No', 'P 0', 'P 3%', 'GST 3%', 'P 5%', 'GST 5%', 'P 12%', 'GST 12%', 'P 18%', 'GST 18%', 'P 28%', 'GST 28%', 'Packing', 'Pack.GST', 'Freight', 'Freight.GST', 'TCS', 'Round', 'Total'];
        excelData.push(headerRow);
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            dataRow.push(formatDate(rowData.BillDate), rowData.BillNumber, rowData.MasterName, rowData.GSTNumber, rowData.Taxable0, rowData.Taxable3, rowData.GST3, rowData.Taxable5, rowData.GST5,
                rowData.Taxable12, rowData.GST12, rowData.Taxable18, rowData.GST18, rowData.Taxable28, rowData.GST28, rowData.PackingAmount, rowData.PackingGST, rowData.FreightAmount, rowData.FreightGSTAmount,
                rowData.TCSAmount, rowData.RoundOff, rowData.TotalAmount);

            excelData.push(dataRow);
        });

        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'PurchaseRegister Details');
        XLSX.writeFile(wb, 'PurchaseRegister_Details.xlsx');
    };


    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Bill Date',
        'Bill No.',
        'Name',
        'GST No',
        'P 0',
        'P 3%',
        'GST 3%',
        'P 5%',
        'GST 5%',
        'P 12%',
        'GST 12%',
        'P 18%',
        'GST 18%',
        'P 28%',
        'GST 28%',
        'Packing',
        'Pack.GST',
        'Freight',
        'Freight.GST',
        'TCS',
        'Round',
        'Total',
    ]);



    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const grandTotal = filteredDataItem
        .filter((rowData) => rowData.MasterName === "Total")
        .reduce(
            (totals, rowData) => ({
                Taxable0:
                    totals.Taxable0 + (parseFloat(rowData.Taxable0) || 0),
                Taxable3:
                    totals.Taxable3 + (parseFloat(rowData.Taxable3) || 0),
                GST3:
                    totals.GST3 + (parseFloat(rowData.GST3) || 0),
                Taxable5:
                    totals.Taxable5 + (parseFloat(rowData.Taxable5) || 0),
                GST5:
                    totals.GST5 + (parseFloat(rowData.GST5) || 0),
                Taxable12:
                    totals.Taxable12 + (parseFloat(rowData.Taxable12) || 0),
                GST12:
                    totals.GST12 + (parseFloat(rowData.GST12) || 0),
                Taxable18:
                    totals.Taxable18 + (parseFloat(rowData.Taxable18) || 0),
                GST18:
                    totals.GST18 + (parseFloat(rowData.GST18) || 0),
                Taxable28:
                    totals.Taxable28 + (parseFloat(rowData.Taxable28) || 0),
                GST28:
                    totals.GST28 + (parseFloat(rowData.GST28) || 0),
                PackingAmount:
                    totals.PackingAmount + (parseFloat(rowData.PackingAmount) || 0),
                PackingGST:
                    totals.PackingGST + (parseFloat(rowData.PackingGST) || 0),
                FreightAmount:
                    totals.FreightAmount + (parseFloat(rowData.FreightAmount) || 0),
                FreightGSTAmount:
                    totals.FreightGSTAmount + (parseFloat(rowData.FreightGSTAmount) || 0),
                TCSAmount:
                    totals.TCSAmount + (parseFloat(rowData.TCSAmount) || 0),
                RoundOff:
                    totals.RoundOff + (parseFloat(rowData.RoundOff) || 0),
                TotalAmount:
                    totals.TotalAmount + (parseFloat(rowData.TotalAmount) || 0)
            }),
            {
                Taxable0: 0,
                Taxable3: 0,
                GST3: 0,
                Taxable5: 0,
                GST5: 0,
                Taxable12: 0,
                GST12: 0,
                Taxable18: 0,
                GST18: 0,
                Taxable28: 0,
                GST28: 0,
                PackingAmount: 0,
                PackingGST: 0,
                FreightAmount: 0,
                FreightGSTAmount: 0,
                TCSAmount: 0,
                RoundOff: 0,
                TotalAmount: 0,

            }
        );


    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    return (

        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-1%' }}>
            <br></br>

            <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                {/* Title */}
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    PURCHASE REGISTER
                </h6>

                {/* Search Bar */}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '5px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',

                        }}
                    />
                </div>

                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px', marginTop: '-10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>



                <Tooltip
                    title="Refresh For Data Load"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'darkolivegreen',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#C9E9D2', color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Export to Excel"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#F2DEDE',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ backgroundColor: '#F2DEDE', color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>EXCEL</span>
                    </Button>
                </Tooltip>
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{ padding: '6px', cursor: 'move', color: '#640D5F', fontWeight: 'bold' }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>


                        <TableBody>
                            {processedData
                                .filter(rowData => rowData.MasterName !== "Total") // Exclude "GrandTotal" for the main rows
                                .map((rowData, index) => {
                                    // Map the rowData to columns based on the column order
                                    const rowValues = {
                                        'Bill Date': rowData.BillDate ? formatDate(rowData.BillDate) : '',
                                        'Bill No.': rowData.BillNumber || '',
                                        Name: rowData.MasterName || '',
                                        'GST No': rowData.GSTNumber || '',
                                        'P 0': rowData.Taxable0 ? parseFloat(rowData.Taxable0).toFixed(2) : '0.00',
                                        'P 3%': rowData.Taxable3 ? parseFloat(rowData.Taxable3).toFixed(2) : '0.00',
                                        'GST 3%': rowData.GST3 ? parseFloat(rowData.GST3).toFixed(2) : '0.00',
                                        'P 5%': rowData.Taxable5 ? parseFloat(rowData.Taxable5).toFixed(2) : '0.00',
                                        'GST 5%': rowData.GST5 ? parseFloat(rowData.GST5).toFixed(2) : '0.00',
                                        'P 12%': rowData.Taxable12 ? parseFloat(rowData.Taxable12).toFixed(2) : '0.00',
                                        'GST 12%': rowData.GST12 ? parseFloat(rowData.GST12).toFixed(2) : '0.00',
                                        'P 18%': rowData.Taxable18 ? parseFloat(rowData.Taxable18).toFixed(2) : '0.00',
                                        'GST 18%': rowData.GST18 ? parseFloat(rowData.GST18).toFixed(2) : '0.00',
                                        'P 28%': rowData.Taxable28 ? parseFloat(rowData.Taxable28).toFixed(2) : '0.00',
                                        'GST 28%': rowData.GST28 ? parseFloat(rowData.GST28).toFixed(2) : '0.00',
                                        'Packing': rowData.PackingAmount ? parseFloat(rowData.PackingAmount).toFixed(2) : '0.00',
                                        'Pack.GST': rowData.PackingGST ? parseFloat(rowData.PackingGST).toFixed(2) : '0.00',
                                        'Freight': rowData.FreightAmount ? parseFloat(rowData.FreightAmount).toFixed(2) : '0.00',
                                        'Freight.GST': rowData.FreightGSTAmount ? parseFloat(rowData.FreightGSTAmount).toFixed(2) : '0.00',
                                        'TCS': rowData.TCSAmount ? parseFloat(rowData.TCSAmount).toFixed(2) : '0.00',
                                        'Round': rowData.RoundOff ? parseFloat(rowData.RoundOff).toFixed(2) : '0.00',
                                        'Total': rowData.TotalAmount ? parseFloat(rowData.TotalAmount).toFixed(2) : '0.00',
                                    };

                                    return (
                                        <TableRow
                                            key={rowData.Id || index}
                                            sx={{
                                                backgroundColor:
                                                    rowData.MasterName === "Master" ? '#D3F1DF' : 'transparent',
                                            }}
                                        >
                                            {columnOrder.map((col, idx) => (
                                                <TableCell
                                                    key={idx}
                                                    sx={{
                                                        borderBottom: '1px solid #E4E0E1',
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {rowValues[col]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}

                        </TableBody>

                        <TableRow
                            key="Total"
                            sx={{ backgroundColor: '#F3F3F3', fontWeight: 'bold' }}
                        >
                            {columnOrder.map((col, idx) => {
                                let cellStyle = {};
                                let cellValue = '';

                                if (col === 'P 0') {
                                    cellValue = grandTotal.Taxable0;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                } else if (col === 'P 3%') {
                                    cellValue = grandTotal.Taxable3;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                } else if (col === 'GST 3%') {
                                    cellValue = grandTotal.GST3;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                } else if (col === 'P 5%') {
                                    cellValue = grandTotal.Taxable5;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                } else if (col === 'GST 5%') {
                                    cellValue = grandTotal.GST5;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                } else if (col === 'P 12%') {
                                    cellValue = grandTotal.Taxable12;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }
                                else if (col === 'GST 12%') {
                                    cellValue = grandTotal.GST12;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }
                                else if (col === 'P 18%') {
                                    cellValue = grandTotal.Taxable18;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                }
                                else if (col === 'GST 18%') {
                                    cellValue = grandTotal.GST18;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                }
                                else if (col === 'P 28%') {
                                    cellValue = grandTotal.Taxable28;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                }
                                else if (col === 'GST 28%') {
                                    cellValue = grandTotal.GST28;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                }
                                else if (col === 'Packing') {
                                    cellValue = grandTotal.PackingAmount;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }
                                else if (col === 'Pack.GST') {
                                    cellValue = grandTotal.PackingGST;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }
                                else if (col === 'Freight') {
                                    cellValue = grandTotal.FreightAmount;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                }
                                else if (col === 'Freight.GST') {
                                    cellValue = grandTotal.FreightGSTAmount;
                                    cellStyle = { backgroundColor: '#F3F3F3' };
                                }
                                else if (col === 'TCS') {
                                    cellValue = grandTotal.TCSAmount;
                                    cellStyle = { backgroundColor: '#D9EDF7' };
                                }
                                else if (col === 'Round') {
                                    cellValue = grandTotal.RoundOff;
                                    cellStyle = { backgroundColor: '#F2DEDE' };
                                }
                                else if (col === 'Total') {
                                    cellValue = grandTotal.TotalAmount;
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }
                                else if (col === 'Total') {
                                } else if (col === 'Bill Date') {
                                    cellValue = 'Grand Total';
                                    cellStyle = { backgroundColor: '#DFF0D8' };
                                }

                                return (
                                    <TableCell key={idx} style={{ padding: '7px', ...cellStyle }}>
                                        {cellValue}
                                    </TableCell>
                                );
                            })}
                        </TableRow>


                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100]}
                                    count={filteredDataItem.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}

                                />
                            </TableRow>


                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }




}
export default PurchaseRegisterReport;